module.exports = __webpack_public_path__ + "img/icon-ios-action2.43332807.svg";